/**
 * Predefined category colors for task categorization
 */
export const CATEGORY_COLORS = [
  '#3b82f6', // Blue
  '#8b5cf6', // Purple
  '#ec4899', // Pink
  '#f59e0b', // Amber
  '#10b981', // Emerald
  '#06b6d4', // Cyan
  '#ef4444', // Red
  '#84cc16', // Lime
  '#f97316', // Orange
  '#6366f1', // Indigo
];

export const GROUP_COLORS = ['#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#06b6d4'];
export const GROUP_ICONS = ['📋', '📁', '🚀', '⚡', '🎯', '💼', '🔧', '📅'];

